export default "__VITE_ASSET__DeI81lqJ__"